import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { Router } from 'react-router-dom';

import App from './App';
import { store } from './model/store';
import { history } from './model/history';
import './index.css';
import { MetaProvider } from './model/meta';
import { I18n } from './locales/translate';
import { ApolloProvider } from '@apollo/client';
import { apollo } from './model/graphql';
import { ModalWrapper } from './components/Modal/PresentedModal';

ReactDOM.render(
  <Provider store={store}>
    <Router history={history}>
      <MetaProvider>
        <ApolloProvider client={apollo}>
          <ModalWrapper>
            <App />
          </ModalWrapper>
        </ApolloProvider>
      </MetaProvider>
    </Router>
  </Provider>,
  document.getElementById('root') as HTMLElement
);

I18n.onUpdate(() => window.location.reload());
